export default "__VITE_ASSET__D0lL_EOG__"